import React, { PureComponent } from 'react';
import { ScrollView } from 'react-native';
import Text from '@dbk/ui-text';
import { createContainer } from '@dbk-legacy/muster/react';
import PropTypes from 'prop-types';
import { View } from '@dbk/ui-react-utils';
import { NotificationWarning } from '@dbk/ui-icons';
import { Accordion, AccordionItem } from '@dbk/ui-accordion';
import find from 'lodash/find';
import pullAll from 'lodash/pullAll';
import pull from 'lodash/pull';
import filter from 'lodash/filter';
import findIndex from 'lodash/fp/findIndex';
import map from 'lodash/map';
import assign from 'lodash/assign';
import ReportUnreadRMDocListItem from './report-unread-rm-doclist-item';
import ReportRMListHeader from './report-rm-list-header';
import ReportMarkReadOrDownload from '../report-category-doclist/report-mark-read-download';
import { EDELIVERY, SELECTED_RANGE, CSV, PDF, TXT, SUCCESS_RESPONSE_CODE } from '../constants';
import { AccordionPlusIcon, AccordionMinusIcon } from '../../../../../../src/components/common/icons';
import ReportRMSelectAll from './report-rm-select-all';
import ReportEmptyData from './report-rm-empty-data';
import BlurModal from '../../../../../../src/components/common/blur-modal';
import AttachmentDownload from '../../../../../../src/utils/attachment-download';
import download from '../../../../../../src/muster/utils/downloader';
import { LoadingCircle } from '../../../../../../src/components/common/loading';
import ReportPreview from '../report-preview';
import { PALETTE } from '../../../../../../src/constants';
import moment from 'moment';

class ReportRMDocList extends PureComponent {

  state = {
    isSelectAllChecked: false,
    isSelectAllIndeterminate: false,
    isCategoryChecked: false,
    isShowUnreadOnlyChecked: false,
    selectedIdsForMarkAsRead: [],
    selectedCategoryList: [],
    unreadList: [],
    showMarkAsRead: false,
    checkedItemList: [],
    hideWarning: true,
    selectedIdsForDownload: [],
    downloadLoadingFlag: false,
    activeAccordionItem: [],
    nextOffset: 1,
    modalVisible: false,
    documentId: null,
    docName: null,
    pdfByteStream: '',
    downloadInProgress: false,
    extType: '',
    documentType: ''
  }

  componentDidMount() {
    this.modifyDefaultListAndUnredListWithReadProperty();
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      reports: {
        selectedCategoryId,
        selectedReportDetailsDateRange,
        rm: {
          customRangeUnreadList,
          lastWeekUnread,
          lastMonthUnread } } } = this.props;

    if ((prevProps.reports.selectedCategoryId && prevProps.reports.selectedCategoryId
      !== selectedCategoryId) || (prevProps.reports.selectedReportDetailsDateRange !== selectedReportDetailsDateRange) ||
      (prevProps.reports.rm.customRangeUnreadList !== customRangeUnreadList) ||
      (prevProps.reports.rm.lastWeekUnread !== lastWeekUnread) ||
      (prevProps.reports.rm.lastMonthUnread !== lastMonthUnread)
    ) {
      this.modifyDefaultListAndUnredListWithReadProperty();
    }
    if(document.querySelector('.error-title')){
      document.querySelector('.error-title').focus();
    }
  }


  /**
  * resetting state
  */
  resetState() {
    this.setState(
      {
        isSelectAllChecked: false,
        isSelectAllIndeterminate: false,
        isCategoryChecked: false,
        isShowUnreadOnlyChecked: false,
        selectedIdsForMarkAsRead: [],
        selectedCategoryList: [],
        unreadList: [],
        showMarkAsRead: false,
        checkedItemList: [],
        hideWarning: false,
        selectedIdsForDownload: [],
        downloadLoadingFlag: false,
        activeAccordionItem: [],
        nextOffset: 1
      }
    );
  }

  /**
   * adding isChecked and isIndeterminate properties to the
   * category and documents.
   */
  modifyDefaultListAndUnredListWithReadProperty = () => {
    this.resetState();
    const defaultList = [];
    let defaultUnreadList = [];
    const { reports: { selectedCategoryId, rm: { lastWeekUnread, lastMonthUnread,
      customRangeUnreadList },
      selectedReportDetailsDateRange } } = this.props;

    if (selectedReportDetailsDateRange === SELECTED_RANGE.CUSTOM) {
        if(!this.props.reports.startDate && !this.props.reports.endDate){
          const currentDate = moment();
          const firstDayOfYear = moment().startOf('year');
          this.props.getCustomRangeDocuments(firstDayOfYear, currentDate);
        }
      defaultUnreadList = this.getModifiedUnreadList(customRangeUnreadList);
    }
    else {
      // iterate through list and unreadStatementList to add isChecked property
      defaultUnreadList = (selectedReportDetailsDateRange === SELECTED_RANGE.LAST_WEEK) ?
        lastWeekUnread : lastMonthUnread;
      defaultUnreadList = this.getModifiedDefaultList(defaultUnreadList);
    }
    if (selectedCategoryId === EDELIVERY.UNREAD_CATEGORY_ID)
      this.setTotalDocs(lastWeekUnread, lastMonthUnread, customRangeUnreadList);

    this.setCategoryListAndUnreadCategoryList(selectedCategoryId, defaultList, defaultUnreadList[0] && defaultUnreadList[0].documentMetadataList);
  }

  getModifiedDefaultList = (list) => {
    if (list && list.length > 0) {
      list.map((item) => {
        const category = item;
        category.categoryChecked = false;
        const updatedMetaDataList = map(category.documentMetadataList, o => assign(o, { categoryChecked: false }));
        category.documentMetadataList = updatedMetaDataList;
        return item;
      })
    }
    return list;
  }

  getModifiedUnreadList = (defaultUnreadList) => {
    if (defaultUnreadList) {
      defaultUnreadList.map((item) => {
        const category = item;
        category.categoryChecked = false;
        const updatedMetaDataList = map(category.documentMetadataList, o => assign(o, { categoryChecked: false }));
        category.documentMetadataList = updatedMetaDataList;
        return item;
      })
    }
    return defaultUnreadList;
  }

  // setCategoryListAnd unread category list
  setCategoryListAndUnreadCategoryList = (selectedCategoryId, list, unreadList) => {
    // find object from list by selected categoryId
    const selectedList = this.getReportListById(list, selectedCategoryId);
    this.setState({
      selectedCategoryList: (selectedList && selectedList.documentMetadataList) ? selectedList : [],
      unreadList
    });
  }

  /**
   * function to check if all items in unread list are checked or not
   * if not select all checkbox will be unchecked
   */
  checkAllItemCheckedInUnreadList = (unreadList) => {
    const unreadCategoryList = unreadList;
    const checkedList = filter(unreadCategoryList, (o) => (o.categoryChecked === undefined || o.categoryChecked === false));
    if (checkedList && checkedList.length > 0) {
      return false;
    }
    return true;
  }

  /**
   * method to handle category click in accordion
   */
  handleCategoryClick = (document) => {
    const documentId = document.documentId;
    const documentName = document.documentName;
    let newCheckedList = [];
    const unreadCategoryList = [...this.state.unreadList];
    let selectedIdsForDownload = [...this.state.selectedIdsForDownload];
    const checkedCategoryList = find(unreadCategoryList, { documentId });
    const index = findIndex({ documentId }, this.state.unreadList);
    let documentList = this.state.selectedIdsForMarkAsRead;
    if (checkedCategoryList) {
      // check if category is checked or indeterminate
      if (checkedCategoryList.categoryChecked || checkedCategoryList.categoryIndeterminate) {
        documentList = pull(documentList, documentId);
        documentList = pull(selectedIdsForDownload, documentId);
        checkedCategoryList.categoryChecked = false;
      } else {
        if (documentList && documentList.indexOf(documentId) < 0 && !checkedCategoryList.read) {
          documentList.push(documentId)
        }

        const checkedItem = { documentId, documentName };
        newCheckedList.push(checkedItem);
        selectedIdsForDownload.push(documentId);
        newCheckedList = [...this.state.checkedItemList, ...newCheckedList];
        checkedCategoryList.categoryChecked = true;
      }
      // TODO:: replace item at index
      unreadCategoryList[index] = checkedCategoryList;
      selectedIdsForDownload = selectedIdsForDownload.filter((item, i, ar) => ar.indexOf(item) === i);
      this.setState({
        unreadList: unreadCategoryList,
        selectedIdsForMarkAsRead: documentList,
        isSelectAllChecked: this.checkAllItemCheckedInUnreadList(unreadCategoryList),
        checkedItemList: newCheckedList,
        selectedIdsForDownload
      });
    }
  }

  /**
   * get report list by selected id
   */
  getReportListById = (list, selectedCategoryId) => find(list,
    { docCategoryId: selectedCategoryId })

  /**
  * method to handle onPress of Mark as Read
  */
  handleMarkasReadOnclick = () => {
    this.props.markDocumentsAsRead(this.state.selectedIdsForMarkAsRead)
  }

  downloader = () => {
    const {
      settings: { currentEnvironment: { remoteUrl } },
      auth: { userId, authHeader, langCode },
      i18n: { messages }
    } = this.props;

    const RSA_URL = remoteUrl + '/edelivery/' + this.props.app.config.apiverion + '/downloadDocumentsInBinary';

    this.props.setShowSpinner(true);
    for (let j = 0; j < this.state.selectedIdsForDownload.length; j++) {
      const body = { "userId": userId, "branchCode": this.props.app.user.selectedPortfolio.branchCode, "channel": "WEB", "language": langCode, "documentIds": [this.state.selectedIdsForDownload[j]] };
      let documentName = '';
      documentName = this.state.checkedItemList[j].documentName;
      const that = this;

      const x = new XMLHttpRequest();
      x.open('POST', RSA_URL, true);
      x.setRequestHeader('Authorization-Token', authHeader);
      x.setRequestHeader('content-type', 'application/json');
      x.setRequestHeader('Accept', 'application/octet-stream');
      // x.setRequestHeader('Authorization', 'Bearer 7b6985ad2ab73fa260b495f4b462d63a');
      // x.setRequestHeader("Access-Control-Allow-Origin", "*");
      // x.setRequestHeader("Access-Control-Allow-Credentials", "true");
      // x.setRequestHeader("Access-Control-Allow-Methods", "GET,HEAD,OPTIONS,POST,PUT");
      // x.setRequestHeader("Access-Control-Allow-Headers", "Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers");

      x.setRequestHeader(
        'Content-Disposition',
        'inline; filename=' + documentName
      );
      x.setRequestHeader(
        'Cache-Control',
        'no-cache, no-store, must-revalidate'
      );
      x.setRequestHeader('Pragma', 'no-cache');
      x.setRequestHeader('Expires', '0');
      x.responseType = 'arraybuffer';
      x.timeout = 300000;
      x.ontimeout = function () {
        that.props.setShowSpinner(false); that.props.setBlurModalError(messages['app.chedelivery.reports.systemErrorMessage']);
      }

      x.onload = function (e) {
        if (x.status === SUCCESS_RESPONSE_CODE) {
          const documentType = x.getResponseHeader('content-type');
          // const ext = documentType.split('/');
          let ext = '';
          if (documentType.includes('/pdf')) {
            ext = PDF;
          } else {
            ext = '.' + documentType.split(';')[0].split('/')[1];
          }

          download(x.response, documentName + ext, documentType); // text/csv and
          if (j === (that.state.selectedIdsForDownload.length - 1)) {
            if (that.props.reports.selectedReportDetailsDateRange === SELECTED_RANGE.CUSTOM) {
              // that.props.getCustomRangeDocuments(that.props.reports.startDate, that.props.reports.endDate);
              that.props.getCustomRangeDocuments(that.props.reports.startDate, that.props.reports.endDate).then(() => {
                that.setState({ downloadLoadingFlag: false });
              });
            } else {
              that.props.getDocuments().then(() => {
                that.setState({ downloadLoadingFlag: false });
              });
            }
          }
        } else {
          that.props.setBlurModalError(messages['app.chedelivery.reports.systemErrorMessage']);
        }

        that.props.setShowSpinner(false);
      };

      x.send(JSON.stringify(body));

      x.onerror = function (e) {
        that.props.setShowSpinner(false);
        that.props.setBlurModalError(messages['app.chedelivery.reports.systemErrorMessage']);
      };
    }
  }


  fetchDocumentToPreview = (documentId) => {
    const {
      settings: { currentEnvironment: { remoteUrl } },
      auth: { userId, authHeader, langCode, documentDownloadDisabled },
      i18n: { messages }
    } = this.props;

    this.setState({ downloadInProgress: true });
    const RSA_URL = remoteUrl + '/edelivery/' + this.props.app.config.apiverion + '/downloadDocumentsInBinary';

    const body = { "userId": userId, "branchCode": this.props.app.user.selectedPortfolio.branchCode, "channel": "WEB", "language": langCode, "documentIds": [documentId] };
    const documentName = '';
    const that = this;

    const x = new XMLHttpRequest();
    x.open('POST', RSA_URL, true);
    x.setRequestHeader('Authorization-Token', authHeader);
    x.setRequestHeader('content-type', 'application/json');
    x.setRequestHeader('Accept', 'application/octet-stream');
    // x.setRequestHeader('Authorization', 'Bearer 6265acfa8564872ddfcbaca12e2b0d5b');
    x.setRequestHeader(
      'Content-Disposition',
      'inline; filename=' + documentName
    );
    x.setRequestHeader(
      'Cache-Control',
      'no-cache, no-store, must-revalidate'
    );
    x.setRequestHeader('Pragma', 'no-cache');
    x.setRequestHeader('Expires', '0');
    x.responseType = 'arraybuffer';
    x.timeout = 300000;
    x.ontimeout = function () { that.props.setBlurModalError(messages['app.chedelivery.reports.systemErrorMessage']); }

    x.onload = function (e) {
      // that.setState({pdfByteStream:x.response,  downloadInProgress: false});
      if (x.status === SUCCESS_RESPONSE_CODE) {
        const documentType = x.getResponseHeader('content-type');
        // const ext = documentType.split('/');
        let ext = '';
        if (documentType.includes('/pdf')) {
          ext = '.pdf';
        } else {
          ext = documentType.split(';')[0].split('/')[1];
        }

        if (!that.state.modalVisible) {
          return;
        }

        if (that.detectIE()) {
          if(!documentDownloadDisabled){
          download(x.response, that.state.docName + ext, documentType); // text/csv and
          if (that.props.reports.selectedReportDetailsDateRange === SELECTED_RANGE.CUSTOM) {
            that.props.getCustomRangeDocuments(that.props.reports.startDate, that.props.reports.endDate);
          } else {
            that.props.getDocuments();
          }
          that.setState({ modalVisible: false, docName: null, documentId: null, pdfByteStream: '', extType: '', documentType: '', downloadInProgress: false });
          return;
          }
          that.setState({ modalVisible: false, docName: null, documentId: null, pdfByteStream: '', extType: '', documentType: '', downloadInProgress: false });
          that.props.setBlurModalError(messages['app.rmAccess.genericError']);
          return;
        }

        if (ext !== '.pdf') {
          if(!documentDownloadDisabled){
          // that.setState({ pdfByteStream: x.response, extType: ext, documentType, errorHeader: messages['app.chedelivery.reports.unsupportedTypeHeader'], downloadInProgress: false });
          download(x.response, that.state.docName + ext, documentType); // text/csv and
          if (that.props.reports.selectedReportDetailsDateRange === SELECTED_RANGE.CUSTOM) {
            that.props.getCustomRangeDocuments(that.props.reports.startDate, that.props.reports.endDate);
          } else {
            that.props.getDocuments();
          }
          that.setState({ modalVisible: false, docName: null, documentId: null, pdfByteStream: '', extType: '', documentType: '', downloadInProgress: false });
        }
          that.setState({ modalVisible: false, docName: null, documentId: null, pdfByteStream: '', extType: '', documentType: '', downloadInProgress: false });
          that.props.setBlurModalError(messages['app.rmAccess.genericError']);
        } else {
          that.setState({ pdfByteStream: x.response, extType: ext, documentType, downloadInProgress: false });
        }
      } else {
        that.setState({ modalVisible: false, docName: null, documentId: null, pdfByteStream: '', extType: '', documentType: '', downloadInProgress: false });
        that.props.setBlurModalError(messages['app.chedelivery.reports.systemErrorMessage']);
      }
    };
    x.send(JSON.stringify(body));
    x.onerror = function (e) {
      that.setState({ modalVisible: false, docName: null, documentId: null, pdfByteStream: '', extType: '', documentType: '', downloadInProgress: false });
      that.props.setBlurModalError(messages['app.chedelivery.reports.systemErrorMessage']);
    };
  }

  detectIE = () => {
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf('MSIE '); // IE 10 or older => return version number
    const trident = ua.indexOf('Trident/'); // IE 11 => return version number
    const edge = ua.indexOf('Edge/'); // IE 12 => return version number
    if (msie > 0 || trident > 0 || edge > 0) {
      return true;
    }
    return false;
  }



  /**
  * method to handle onPress of Download/ Preview
  */
  handlePdfClick = (document) => {
    this.setState({
      modalVisible: true, documentId: document.documentId, docName: document.documentName,
      pdfByteStream: '', extType: '', documentType: ''
    });
    this.fetchDocumentToPreview(document.documentId);
  }

  /**
  * method to handle onPress of Download/ Preview
  */
  handlePreviewnDownloadClick = () => {
    const {
      auth: { documentDownloadDisabled }
    } = this.props;
    // this.props.downloadDocuments(this.state.selectedIdsForDownload[0]);
    if(!documentDownloadDisabled){
      this.setState({ downloadLoadingFlag: true });
      this.downloader();
    }
  }

  /**
   * method to handle select all checkbox click.
   * this will store all selected report ids into an array.
   * later, the array will be used for 'Mark as read' functionality
   */
  handleSelectAllClick = () => {
    let isChecked = false;
    if (this.state.isSelectAllChecked) {
      isChecked = false;
    } else {
      isChecked = true;
    }
    // storing selected documents list in state, which will be used for mark as read
    this.setItemsAsCheckedOrUnchecked(isChecked);
  }


  // TODO:: code refactoring
  setItemsAsCheckedOrUnchecked = (isChecked) => {
    const documentsIdList = [];
    const newCheckedList = [];
    const selectedIdsForDownload = [...this.state.selectedIdsForDownload];
    const unreadList = [...this.state.unreadList];
    if (isChecked) {
      unreadList.map((item) => {
        item.categoryChecked = true;
        if (documentsIdList.indexOf(item.documentId) < 0 && !item.read) {
          documentsIdList.push(item.documentId)
        }
        if (!selectedIdsForDownload.includes(item.documentId)) {
          selectedIdsForDownload.push(item.documentId);
          const checkedItem = { documentId: item.documentId, documentName: item.documentName };
          newCheckedList.push(checkedItem);
        }
      })
    } else {
      unreadList.map((item) => {
        item.categoryChecked = false;
      })
      // to remove all records from the array of document ids
      pullAll(documentsIdList, documentsIdList);
      pullAll(selectedIdsForDownload, selectedIdsForDownload);
    }
    this.setState({
      selectedIdsForMarkAsRead: documentsIdList,
      isSelectAllChecked: isChecked,
      checkedItemList: newCheckedList,
      selectedIdsForDownload,
      unreadList
    });
  }

  /**
   * if cagtegory is selected as UNREAD in level 1/ report home screen,
   * then below method will be used to render report in accordion.
   * @param {*} reportList
   */
  renderUnreadCategoryListInAccordion = (reportList) => reportList && Object.keys(reportList).map((item, index) => {
    const isRowActive = this.state.activeAccordionItem.indexOf(index) !== -1;
    return (<AccordionItem
      active={isRowActive}
      className="ReportDocListAccordionItems UnreadDocAcc"
      renderTitle={() =>
        <ReportRMListHeader
          categoryName={reportList[item].documentName}
          portfolioId={reportList[item].portfolioId}
          referenceCurrency={reportList[item].refCurrency}
          receivedDate={reportList[item].receivedDate}
          totalItems={0}
          pdfClick={() => this.handlePdfClick(reportList[item])}
          handleCategoryClick={() => this.handleCategoryClick(reportList[item])}
          isChecked={reportList[item].categoryChecked}
          isRead = {reportList[item].read} />
      }
      style={{ color: '#a7a8aa' }}
      itemKey={index}
      key={reportList[item].documentId}
    >
      {this.renderUnreadCategoryList(reportList[item], this.state.nextOffset)}
    </AccordionItem>)
  })

  /**
   * method to render unread cagtegory report list
   * @param {*} item
   */
  renderUnreadCategoryList = (list, nextOffset) => (
    <div style={{ position: 'relative' }}>
      <ReportUnreadRMDocListItem
        isActive
        categoryReportList={list}
        nextOffset={nextOffset}
        showSeperator={false} />
    </div>
  )


  getTotalDocsForRange = () => {

    const {
      reports: {
        selectedReportDetailsDateRange,
        totalDocs7Days,
        totalDocs30Days,
        totalDocsCustomRange
      } } = this.props;
    let docsCount = 0;
    if (selectedReportDetailsDateRange === SELECTED_RANGE.CUSTOM) {
      docsCount = totalDocsCustomRange;
    }
    else if (selectedReportDetailsDateRange === SELECTED_RANGE.LAST_WEEK) {
      docsCount = totalDocs7Days;
    }
    else if (selectedReportDetailsDateRange === SELECTED_RANGE.LAST_MONTH) {
      docsCount = totalDocs30Days;
    }
    return docsCount;
  }

   /**
         * function to handle Show Unread Only check box click.
         * only unread documents/report list should be displayed on check of the
         */
        handleShowUnreadOnlyClick = () => {
          if (this.state.isShowUnreadOnlyChecked) {

              this.modifyDefaultListAndUnredListWithReadProperty();
              this.setState({
                  isShowUnreadOnlyChecked: false,
                  isSelectAllChecked: false
              });
              this.props.reports.setShowUnreadOnlyChecked(false);

              return;
          }
          const selectedList = { ...this.state.unreadList };
          const filteredUnreadList = filter(selectedList, { read: false });

          this.setState({
              unreadList: filteredUnreadList,
              isShowUnreadOnlyChecked: true,
              // selectedIdsForDownload: this.state.selectedIdsForMarkAsRead
          });
          this.props.reports.setShowUnreadOnlyChecked(true);

      }


  /**
   * function to return report page header
   * (Select ALL and Show Unread Only options view)
   */
  getDoclistHeader = () => {
    const { reports: { selectedCategoryId } } = this.props;
    let isCategoryListEmpty = false;

    const unreadCategorySelected = selectedCategoryId === EDELIVERY.UNREAD_CATEGORY_ID
    if (unreadCategorySelected) {
      if (this.state.unreadList && this.state.unreadList.length <= 0) {
        isCategoryListEmpty = true;
      }
    }

    const count = this.getTotalDocsForRange();

    if (!isCategoryListEmpty && count > 0) {

      return (
        <ReportRMSelectAll

          handleSelectAllClick={this.handleSelectAllClick}
          handleShowUnreadOnlyClick={this.handleShowUnreadOnlyClick}
          isSelectAllChecked={this.state.isSelectAllChecked}
          isShowUnreadOnlyChecked={this.state.isShowUnreadOnlyChecked}

        />);
    }
  }

  /**
   * function to return mark as read view
   */
  getMarkAsReadView = () => {
    if (this.state.selectedIdsForMarkAsRead.length > 0 || this.state.selectedIdsForDownload.length > 0) {
      return (
        <View>
          <ReportMarkReadOrDownload
            downloadCount={this.state.selectedIdsForDownload.length}
            markAsReadCount={this.state.selectedIdsForMarkAsRead.length}
            handleMarkasReadOnclick={this.handleMarkasReadOnclick}
            handlePreviewnDownloadClick={this.handlePreviewnDownloadClick}
            downloadLoadingFlag={this.state.downloadLoadingFlag}
          />
        </View>
      );
    }
  }

  /**
   * function to return report doclist body
   */
  getDocListBody = () => {
    if (this.state.unreadList && this.state.unreadList.length > 0) {
      return (
        <View>
          <Accordion
            fullWidth
            activeItems={this.state.activeAccordionItem.length > 0 ? this.state.activeAccordionItem : []}
            renderIconForOpen={() => <AccordionMinusIcon color={PALETTE.primaryActive} />}
            renderIconForClose={() => <AccordionPlusIcon />}
            allowMultiple={false}
            onChange={this.handleAccordionChange}>

            {this.renderUnreadCategoryListInAccordion(this.state.unreadList)}
          </Accordion>
        </View>
      );
    }
    // if no items in documentMetadataList then show no records found view
    return (<ReportEmptyData />);
  }

  /**
   * function: to set 7 days and 30 days count in level 2
   */
  setTotalDocs = (weekList, monthList, customRangeList) => {
    const weekData = weekList;
    const monthData = monthList;
    const customRangeData = customRangeList;
    const totalDocs7Days = this.getTotalDocs(weekData);
    const totalDocs30Days = this.getTotalDocs(monthData);
    const totalDocsCustomRange = this.getTotalDocs(customRangeData);
    this.props.setTotalDocs(totalDocs7Days, totalDocs30Days, totalDocsCustomRange);
  }

  getTotalDocs = (list) => {
    let totalDocs = 0;
    list.map((item) => {
      totalDocs += item.documentMetadataList.length;
    });
    return totalDocs;
  }



  downloadModalContent = () => {
    const { i18n: { messages }, reports: { pdfBinaryData, docIDforDownload }, getDocuments, setPdfBinaryData } = this.props;
    let documentName = '';

    for (let i = 0; i < Object.keys(this.state.checkedItemList).length; i++) {
      if (this.state.checkedItemList[i].documentId === docIDforDownload) {
        documentName = this.state.checkedItemList[i].documentName;
      }
    }

    if (!pdfBinaryData) {
      this.props.setBlurModalError(messages['app.chedelivery.reports.systemErrorMessage']);
    } else if (documentName !== '') {
      const isDownloaded = AttachmentDownload(documentName, pdfBinaryData);
      const url = 'data:application/pdf;base64,' + pdfBinaryData;
      if (!isDownloaded) {
        return (
          <div className="pad-10">
            <embed
              src={url}
              width="100%"
              style={{ minHeight: this.props.screen.height - 75 }}
            />
          </div>
        );
      }
    }
    setPdfBinaryData('');
    let docIdIndex = '';
    for (let i = 0; i < this.state.selectedIdsForDownload.length; i++) {
      if (this.state.selectedIdsForDownload[i] === docIDforDownload) {
        docIdIndex = i;
      }
    }

    if (docIdIndex !== '') {
      docIdIndex += 1;
    }
    if (docIdIndex !== '' && this.state.selectedIdsForDownload[docIdIndex]) {
      this.props.downloadDocuments(this.state.selectedIdsForDownload[docIdIndex]);
    } else if (this.state.selectedIdsForDownload[docIdIndex] === undefined) {
      getDocuments();
    }
  }

  /**
* function: closeBlurModel will update the state and hide the BlurModel
*/
  closeBlurModel = () => {
    this.setState({ hideWarning: true });
    this.props.setBlurModalError(null);
  };

  renderErrorModal = () => {
    const { reports: { blurModalError } } = this.props;
    return (
      <div className="row">
        <div className="small-12 text-center">
          <div className="center">
            <NotificationWarning color='#b92635' secondaryColor='#152139' width={50} height={50} />
            <div className="pad-top-25 pad-bottom-25 center">
              <div className="error-title" tabIndex={0}>
                <Text numberOfLines={1}>{blurModalError}</Text>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  /**
 * handle accordion item selection change
 */
  handleAccordionChange = (activeItems) => {
    this.setState({
      nextOffset: 1,
      activeItems: [],
      activeAccordionItem: activeItems
    });
    this.props.activeItemChanged(true);
  }



  closePdf = () => {
    this.setState({ documentId: null });
  }

  closeBlurModel = () => {
    if (this.state.documentId != null) {
      return;
    }
    this.setState({ modalVisible: false, docName: null, documentId: null, pdfByteStream: '', extType: '', documentType: '' });
    // this.props.reports.setPdfBinaryData('');
    this.props.resetDocumentData();
    // if(this.props.reports.selectedReportDetailsDateRange === SELECTED_RANGE.CUSTOM){
    //     this.props.getCustomRangeDocuments(this.props.reports.startDate, this.props.reports.endDate);
    // }else{
    //     this.props.getDocuments();
    // }
  }

  render() {
    const { i18n: { messages }, screen, reports: { blurModalError, pdfBinaryData } } = this.props;

    if (pdfBinaryData !== '') {
      this.downloadModalContent();
    }

    if (blurModalError !== null) {
      return (
        <BlurModal
          visible={this.state.hideWarning === false}
          doneVisible={false}
          title={messages['app.chedelivery.reports.systemErrorTitle']}
          onDone={() => this.closeBlurModel()}
          className={"model-window-login"}
        >
          {this.renderErrorModal()}
        </BlurModal>
      );
    }


    return (

      <div>
        {this.getDoclistHeader()}
        <div id="container_reports_reportRMDoclist_test" className="scrollBarHover" style={{ width: '100%' }}>
          <ScrollView
            className="scrollBarHide" id="scrollBarHideforRM"
            style={{ marginBottom: 20, paddingLeft: 15, paddingRight: 20 }}
            scrollEnabled
          >
            <div>
              {this.getDocListBody()}
            </div>
          </ScrollView>
        </div>
        <div style={{ marginBottom: 20 }}>
          {this.getMarkAsReadView()}
        </div >

        <div className="large-12">

          <ReportPreview
            screen={screen}
            modalVisible={this.state.modalVisible}
            doneLabel="Close"
            onCloseBlurModel={this.closeBlurModel}
            headerLabel={this.state.docName}
            closePdf={this.closePdf}
            pdfData={this.state.pdfByteStream}
            messages={messages}
            pdfDataDownloadInProgress={this.state.downloadInProgress}
            extType={this.state.extType}
            documentType={this.state.documentType}
            documentDownloadDisabled = {this.props.auth.documentDownloadDisabled}
          />
        </div>

      </div>
    );
  }
}

ReportRMDocList.propTypes = {
  i18n: PropTypes.shape({
    messages: PropTypes.object,
  }),
  isSelectAllChecked: PropTypes.bool,
  isSelectAllIndeterminate: PropTypes.bool,
  isCategoryChecked: PropTypes.bool,
  isShowUnreadOnlyChecked: PropTypes.bool,
  selectedIdsForMarkAsRead: PropTypes.array,
  selectedCategoryList: PropTypes.array,
  unreadList: PropTypes.array,
  showMarkAsRead: PropTypes.bool,
}

ReportRMDocList.defaultProps = {
  i18n: {},
  isSelectAllChecked: false,
  isSelectAllIndeterminate: false,
  isCategoryChecked: false,
  isShowUnreadOnlyChecked: false,
  selectedIdsForMarkAsRead: [],
  selectedCategoryList: [],
  unreadList: [],
  showMarkAsRead: [],
}


export default createContainer(
  {
    $renderLoading: () => <LoadingCircle />,
    $queries: {
      app: {
        config: {
          apiverion: true
        },
        user: {
          selectedPortfolio: true
        }
      },
      edelivery: {
        getUserPreferences: { $call: 'getUserPreferences' },
        showPrompt: true,
      },
      settings: {
        currentEnvironment: {
          remoteUrl: true,
        },
      },
      auth: {
        userId: true,
        authHeader: true,
        langCode: true,
        documentDownloadDisabled: true,
      },
      changePage: { $call: 'ui.history.push' },
      i18n: {
        messages: true,
      },
      getDocuments: {
        $call: 'reports.getDocuments',
      },
      getLastStatements: {
        $call: 'reports.getLastStatements',
      },
      markDocumentAsCheckedOrUnchecked: {
        $call: 'reports.markDocumentAsCheckedOrUnchecked'
      },
      markDocumentsAsRead: {
        $call: 'reports.markDocumentsAsRead'
      },
      downloadDocuments: {
        $call: 'reports.downloadDocuments'
      },
      setTotalDocs: {
        $call: 'reports.setTotalDocs'
      },
      setBlurModalError: {
        $call: 'reports.setBlurModalError'
      },
      setPdfBinaryData: {
        $call: 'reports.setPdfBinaryData'
      },
      setDownloadDocId: {
        $call: 'reports.setdocIDforDownload'
      },
      setShowSpinner: {
        $set: 'reports.showSpinner'
      },
      setIsScrollLoading: {
        $set: 'reports.isScrollLoading'
      },
      activeItemChanged: {
        $set: 'reports.isActiveItemChanged'
      },
      getCustomRangeDocuments: {
        $call: 'reports.fetchDocumentsForCategories'
      },
      reports: {
        blurModalError: true,
        docIDforDownload: true,
        pdfBinaryData: true,
        showSpinner: true,
        lastMonthStatements: true,
        rm: {
          lastWeekUnread: true,
          lastMonthUnread: true,
          customRangeUnreadList: true
        },
        totalDocs7Days: true,
        totalDocs30Days: true,
        totalDocsCustomRange: true,
        selectedCategoryId: true,
        selectedReportDetailsDateRange: true,
        setShowUnreadOnlyChecked: {
          $set: 'showUnreadOnlyChecked',
        },
        startDate: true,
        endDate: true,

      },
      getStatementPdf: {
        $call: 'monthly.getPdf',
      },
      dailyPdf: {
        pdf: true,
        setEmpty: { $set: 'pdf' },
      },
      resetAdvicesDates: { $call: 'advices.resetDates' },
      resetReportsDates: { $call: 'reports.resetDates' },
      portfolio: {
        netIncome: {
          value: true,
        },
      },
    },
    screen: {
      width: true,
      height: true,
      isSmall: true
    },
  },
)(ReportRMDocList);
